import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	inject
} from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

export interface ITimeMarker {
	startTime: number; // sec
	endTime: number; // sec
	cssClassName?: string;
	isClickDisabled?: boolean;
	contentHtml?: string;
	contentHtmlCssClass?: string;
	markerOnScrubBar?: boolean; //if marker is on the scrub bar itself then set it to true. this will help adjusting heigt of the marker when hover.
	id?: string;
}

@Component({
	selector: 'vb-time-markers',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@for (marker of markers; track markersTrackByFunc($index, marker)) {
			<vb-time-marker
				[ngClass]="[
					'marker',
					marker.cssClassName || '',
					marker.markerOnScrubBar ? 'time-marker-on-scrub-bar' : '',
				]"
				[ngStyle]="{
					left: ( (marker.startTime / (+totalTime)) * 100 ) + '%',
					width: marker.endTime ? (( ( (marker.endTime - marker.startTime) / (+totalTime) ) * 100 ) + '%') : 'auto'
				}"
				(mousedown)="onTimeMarkerClick($event, marker)"
				(mouseup)="onTimeMarkerClick($event, marker)"
				(touchstart)="onTimeMarkerClick($event, marker)"
				(touchend)="onTimeMarkerClick($event, marker)"
			>
				@if (!!marker.contentHtml) {
					<div [ngClass]="marker.contentHtmlCssClass" [innerHTML]="marker.contentHtml"></div>
				}
			</vb-time-marker>
		}
	`,
	standalone: false,
	styleUrls: ['./VbTimeMarkers.Component.ng.less']
})
export class VbTimeMarkersComponent implements OnChanges {
	@Input() public markers: ITimeMarker[];
	@Input() public totalTime: number; // sec

	private markersInternal: ITimeMarker[];
	private api = inject(VideogularComponent);

	public ngOnChanges(): void {
		this.markersInternal = this.totalTime && this.markers ?
			this.markers :
			[];
	}

	public markersTrackByFunc(_index: number, marker: ITimeMarker): string {
		return [
			marker.startTime,
			marker.endTime,
			marker.cssClassName || ''
		].join('$');
	}

	public onTimeMarkerClick($event: Event, marker: ITimeMarker): void {
		if (marker.isClickDisabled) {
			$event.stopPropagation();
		} else {
			this.api.seekTime(marker.startTime);
			this.api.emitVgTimeMarkerClicked(marker);
			$event.stopPropagation();
		}
	}
}
